import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, inject } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { CardThemeSurface, SportsThemedCardHeaderDirective } from '@frontend/sports/common/ui/sports-themed-card';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { ItemComponent } from '@frontend/sports/item/feature';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { MarqueeBackgroundContainerConfig, TitleIconOptions } from '@frontend/sports/types/components/content';
import { MarqueeLink } from '@frontend/sports/types/components/widget/types';
import { DsButton } from '@frontend/ui/button';
import { DsCardHeader } from '@frontend/ui/card-header';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { MarqueeTitleIcon } from './marquee-tile.model';
import { MarqueeTrackingService } from './marquee-tracking.service';

@Component({
    selector: 'ms-header',
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CompetitionLogoComponent,
        DsButton,
        ItemComponent,
        TrustPipe,
        NgClass,
        DsCardHeader,
        SportsThemedCardHeaderDirective,
        IconCustomComponent,
    ],
})
export class HeaderComponent implements OnInit, OnChanges {
    @Input() titleIcon: MarqueeTitleIcon;
    @Input() backgroundContainerConfig: MarqueeBackgroundContainerConfig;
    @Input() globalLinkConfig: MarqueeLink;

    title: string | undefined;
    globalLinkText: string | undefined;
    globalLink: string | undefined;
    globalLinkCount: number | undefined;
    checkTitleIcon: boolean;
    private marqueeTrackingService = inject(MarqueeTrackingService);
    private redirectHelperService = inject(RedirectHelperService);

    themeHeaderSurface: CardThemeSurface = {
        'sportingbet-br': 'low',
        'betboo-br': 'low',
    };

    ngOnInit(): void {
        this.updateChanges();
    }

    ngOnChanges(): void {
        this.updateChanges();
    }

    private updateChanges(): void {
        this.title = this.backgroundContainerConfig.title ?? '';
        this.globalLinkText = this.globalLinkConfig.title;
        this.globalLink = this.globalLinkConfig.linkOverride;
        this.checkTitleIcon = this.backgroundContainerConfig.titleIconDisplay === TitleIconOptions.CompetitionLogo;
    }

    linkClick(): void {
        this.marqueeTrackingService.trackLinkClick(this.globalLink);
        if (this.globalLink) {
            this.redirectHelperService.goToPage(this.globalLink);
        }
    }

    isRequiredTitleIcon(): boolean | undefined {
        return this.backgroundContainerConfig.titleIconDisplay && this.backgroundContainerConfig.titleIconDisplay !== TitleIconOptions.None;
    }
}
